(() => {
  window.addEventListener("abra:activated", () => {
    const discountBannerContent = document.querySelector(
      ".product-single__meta .discount-coupon .discount-coupon__content p"
    );

    if (discountBannerContent) {
      discountBannerContent.textContent = "Your discount has been applied";
    }
  });
})();
